// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3d1LK","row":"ProcedureTreatmentSummary_row__2uN01"};